import { BillingInfo, Contact } from '../schemas/VendorSchema';

import { StripeAccount } from './Stripe';

export enum VendorType {
  none = 'none',
  fareharbor = 'fareharbor',
  peek = 'peek',
  redeam = 'redeam',
  singenuity = 'singenuity',
}

export const IntegrationsVendorTypes = Object.values(VendorType).filter(
  t => t !== 'none'
) as string[];
export const mapVendorTypeToOption = type => ({
  value: type,
  label: `${type[0].toUpperCase()}${type.slice(1)}`,
});
export const VendorTypeOptions = Object.values(VendorType).map(
  mapVendorTypeToOption
);

type VendorBookingPlatforms = {
  type: string;
  supplierId: string;
};

export type BookingPlatformSupplier = {
  id: string;
  name: string;
};

export type Vendor = {
  assignedTier?: string;
  createdAt: string;
  id: string;
  name: string;
  bookingPlatforms: VendorBookingPlatforms[];
  status: string;
  type: VendorType;
  email: string;
  publicEmail: string;
  publicPhoneNumber: string;
  updatedAt: string;
  stripeConnectedAccounts: StripeAccount[];
  billingInfo: BillingInfo;
  contacts: Contact;
  parentVendorId?: string;
};

export type BookingPlatfromActivities = {
  isActive?: boolean;
  supplierId: string;
  supplierName: string;
  itemId: string;
  productId: string;
  name: string;
  activityId: string;
  integration: string;
};

export type SignupVendorPayload = {
  name: string;
  phone: string;
  email: string;
  vendors: string[];
};

export type FranchiseVendor = Pick<Vendor, 'id' | 'name'>;
